import { DescriptionBar } from 'components';
import PricingButton from './PricingButton';
import { pricingType } from './utils';
import 'styles/mobile.css';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const Pricing = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Pricing | IOPS SPACE</title>
        <meta name="description" content="Check out our pricing plans and find the best one for you!" />
      </Helmet>
      <div className="h-full w-full max-w-[800px]">
        <DescriptionBar
          className="mb-2 md:pt-1"
          title={t('pricing.pageTitle')}
          description={t('pricing.pageDescription')}
        />
        <div className="flex w-full flex-1 flex-col gap-4 px-4 py-6 padding-md">
          {pricingType.map(({ title, description, price, onClick }, index) => (
            <PricingButton
              key={`${title}_${index}`}
              title={title}
              description={description}
              onClick={onClick}
              price={price}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Pricing;
